// extracted by mini-css-extract-plugin
export var editButton = "_k6-0";